import axios from '@/axios/axios2'

// 获取伙伴详情基础数据
export const fetchMyPartnerBaseDetail = params =>
  axios.post('/partner/getMyPartnerBaseDetail', params)

// 伙伴详情数据统计
export const fetchMyPartnerStaticDetail = params =>
  axios.post('/partner/getMyPartnerStaticDetail', params)
